import React, { useState } from "react";

import {
  Card,
  ListGroupItem,
  ListGroup,
  Button,
  Row,
  Form
} from "react-bootstrap";

export default function NFT({ tokenContract, account }) {
  const [creatingToken, setCreatingToken] = useState(false);
  const [tokenId, setTokenId] = useState(null);
  const [ipfsHash, setIpfsHash] = useState("");
  const [user, setUser] = useState("");

  const createToken = async () => {
    try {
      setCreatingToken(true);
      const tx = await tokenContract.methods
        .create(user, ipfsHash)
        .send({ from: account });

      setTokenId(tx.events.NewToken.returnValues.tokenId);
      setCreatingToken(false);
    } catch (error) {
      setCreatingToken(false);
    }
  };

  return (
    <Row className="justify-content-center">
      <div style={{ width: "80%" }}>
        <Card className="mt-5 mb-3">
          <Card.Title className="text-center mt-3 p-3 bold">
            NFT Creation
          </Card.Title>
          <Card.Body className="align-self-center" style={{ width: "80%" }}>
            {creatingToken ? (
              <h3>Creating Token...</h3>
            ) : (
              <>
                <Form.Label className="bold">IPFS Hash of Token</Form.Label>
                <Form.Control
                  className="mb-4"
                  type="text"
                  placeholder="QmfPQptyRMiipfJ3poo53DqGn5vbk37LzZCEf6f5sPX5sa"
                  onChange={e => setIpfsHash(e.target.value)}
                  value={ipfsHash}
                />
                <Form.Label className="bold">User Address</Form.Label>
                <Form.Control
                  className="mb-4"
                  type="text"
                  placeholder="0x9E74639034E923abAD35040a6Ad8891664b67E67"
                  onChange={e => setUser(e.target.value)}
                  value={user}
                />
              </>
            )}
          </Card.Body>
          <ListGroup className="list-group-flush">
            <ListGroupItem>
              <strong>Token ID: </strong>
              {tokenId && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://rinkeby.etherscan.io/token/${tokenContract._address}?a=${tokenId}`}
                >
                  {`EID ${tokenId}`}
                </a>
              )}
            </ListGroupItem>
          </ListGroup>
          <Card.Footer className="text-center">
            <Button onClick={createToken}>Create Token</Button>
          </Card.Footer>
        </Card>
      </div>
    </Row>
  );
}
